module.exports = __webpack_public_path__ + "fonts/DM_Sans-900-latin-ext18.49935c4.woff2";